import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled, { css } from 'styled-components';

import claimsRatingDefImg from '@/static/claims/lemonade-claims-rating.png';
import claimsRatingRedImg from '@/static/claims/reddish/lemonade-claims-rating.png';
import type React from 'react';

const claimsRatingImg = {
  pinkish: claimsRatingDefImg.src,
  reddish: claimsRatingRedImg.src,
} as Record<string, string>;

const ClaimsStatsSection = styled.div`
  text-align: center;
`;

const ClaimsStatsInner = styled(Flex).attrs({
  justifyContent: 'center',
})`
  max-width: 1100px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin: 0 auto;
    `}
`;

const ClaimsStatsBox = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;

  p {
    margin-top: 9px;
  }
`;

const ratingStars = css`
  &:after {
    content: '';
    position: absolute;
    background: transparent url(${({ theme }) => claimsRatingImg[theme.name]}) no-repeat;
    background-size: contain;
    width: 87px;
    height: 15px;
    top: -32px;
    left: calc(50% - 43px);

    ${MEDIA_QUERIES.tabletAndDesktop`
            top: -35px;
            left: calc(50% - 72px);
            width: 145px;
            height: 25px;
        `}
  }
`;

const ClaimStatTitle = styled.span`
  ${font('main', {
    fontSize: '5rem',
    lineHeight: '6rem',
    fontWeight: '300',
  })}

  ${MEDIA_QUERIES.tabletAndDesktop`
            ${font('main', {
              fontSize: '10rem',
              lineHeight: '12rem',
              fontWeight: '300',
            })}
        `}
`;

const ClaimStatSubtitle = styled.span`
  display: block;
  text-wrap: pretty;
  ${font('main', { fontSize: '1.8rem', lineHeight: '2.8rem', fontWeight: '400' })}
  ${MEDIA_QUERIES.tabletAndDesktop`
    ${font('main', { fontSize: '2.2rem', lineHeight: '3.4rem', fontWeight: '400' })}
    white-space: pre-wrap;
  `}
`;

const ClaimStat = styled(Flex).attrs({
  width: '45%',
  as: 'li',
  flexDirection: 'column',
})<{ showRatingStars?: boolean }>`
  position: relative;
  ${props => (props.showRatingStars ? ratingStars : '')}

  ${MEDIA_QUERIES.desktop`
    width: 294px;
  `}

  ${MEDIA_QUERIES.tablet`
    width: 50%;
  `}
`;

export type StatsProps = {
  steps: {
    title: string;
    subtitle: string;
    showRatingStars?: boolean;
    order?: number | [number, number, number];
    mt?: [number, number, number];
  }[];
};

export const Stats: React.FC<StatsProps> = ({ steps }) => {
  return (
    <Box my={[60, 100, 100]} mx={0}>
      <ClaimsStatsSection>
        <ClaimsStatsInner alignItems="center" px={20} pt={20}>
          <ClaimsStatsBox>
            {steps.map(step => (
              <ClaimStat key={step.title} {...step} tabIndex={0}>
                <ClaimStatTitle>{step.title}</ClaimStatTitle>
                <ClaimStatSubtitle>{step.subtitle}</ClaimStatSubtitle>
              </ClaimStat>
            ))}
          </ClaimsStatsBox>
        </ClaimsStatsInner>
      </ClaimsStatsSection>
    </Box>
  );
};
